import appconfig from 'app/config';
import appcomponents from 'app/app.components';

routingDynamic.$inject = ['$rootScope', '$location', '$http', '$urlRouter', '$stateRegistry', '$ocLazyLoad', '$templateCache', '$state', '$urlMatcherFactory', 'appService'];

export default function routingDynamic($rootScope, $location, $http, $urlRouter, $stateRegistry, $ocLazyLoad, $templateCache, $state, $urlMatcherFactory)
{
  $urlMatcherFactory.caseInsensitive(true);
  $urlMatcherFactory.strictMode(false);

  // $urlRouter.deferIntercept;
  var excPath = ['/error','/clear-cache'];

  $rootScope.$on('$locationChangeStart', (e) => {
    e.preventDefault();
    if(!window.locationSearch) {
      window.locationSearch = $location.search();
    }
    let path = ($location.$$path).toLowerCase();
    if(excPath.indexOf(path) == -1) {

      const req = new XMLHttpRequest();
      // let path = window.location.pathname.replace('/2024','');config.api+''+$location.$$path
      path = path == '/' ? '/home' : path;
      req.open("GET", appconfig.apiv3+'mlr/content/chakra'+path, true);
      req.responseType = 'json';
      req.send();
      req.onerror = () => { // only triggers if the request couldn't be made at all
        $state.go('error',{},{reload:true});
      };
      req.onload = (e) => {
        if(req.response.status == 'error')
          $state.go('error',{},{reload:true});
        const page = req.response.data; // not responseText
        $rootScope.page = page;
        var component = appcomponents[page.type];
        var state = {
          url: page.slug != 'home' ? '/'+page.slug : '',
          cache: false,
          name: page.type,
          component: component,
          params: window.locationSearch,
          caseInsensitiveMatch: true,
          resolve: {
            page: ['$ocLazyLoad',function(){
              if (page.files) {
                var files = page.files.split(',');
                if (typeof files !== 'undefined' && files.length > 0) {
                  files.forEach(function (file) {
                    if (file.includes('bootstrap/js/dist/carousel')) {
                      import( /* webpackMode: "lazy" */ /* webpackChunkName: "carousel"*/ 'bootstrap/js/dist/carousel');
                    }
                    if (file.includes('bootstrap/scss/carousel')) {
                      import( /* webpackMode: "lazy" */ /* webpackChunkName: "carousel"*/ './common/styles/_carousel.scss');
                    }
                  });
                }
              }
            }]
          },
          // componentProvider: function($transition$) {
          //   return components[page.type]
          // },
          lazyLoad: async ($transition$) => {
            const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
            try {
              await import(
                 /* webpackMode: "lazy" */
                 /* webpackChunkName: `[request]`*/
                `./views/${page.type}/${page.type}.view`
              ).then(mod => {
                $ocLazyLoad.load(mod[component.toUpperCase() + '_VIEW']);
              });
            } catch (err) {
              throw new Error("Ooops, something went wrong, " + err);
            }
          },
        };
        // $location.search(window.locationSearch);
        if(!$stateRegistry.get(page.type)) {
          $stateRegistry.register(state);
          // $urlRouter.listen();
          $urlRouter.sync();
        }
      };
    } else {
      // $urlRouter.listen();
      $urlRouter.sync();
    }
  });
  //
  $rootScope.$on('$locationChangeSuccess',(e) => {
    e.preventDefault();
    $location.search(window.locationSearch);
  });
}
